module.exports = "//static.hsappstatic.net/AdsUI/static-1.38297/imgs/externallink-embed-academy-exp.svg"